import { ConnectButton } from '@rainbow-me/rainbowkit';
import { Button, HStack } from '@chakra-ui/react';

export const CustomConnectButton = () => {
  return (
    <ConnectButton.Custom>
      {({
        account,
        chain,
        openAccountModal,
        openChainModal,
        openConnectModal,
        authenticationStatus,
        mounted,
      }) => {
        // Note: If your app doesn't use authentication, you
        // can remove all 'authenticationStatus' checks
        const ready = mounted && authenticationStatus !== 'loading';
        const connected =
          ready &&
          account &&
          chain &&
          (!authenticationStatus || authenticationStatus === 'authenticated');
        return (
          <div
            {...(!ready && {
              'aria-hidden': true,
              style: {
                opacity: 0,
                pointerEvents: 'none',
                userSelect: 'none',
              },
            })}
          >
            {(() => {
              if (!connected) {
                return (
                  <Button
                    px={6}
                    rounded={8}
                    bg="text.t1"
                    color="bg.t1"
                    fontWeight={500}
                    fontSize="sm"
                    lineHeight={1.5}
                    size="xs"
                    _hover={{
                      opacity: 0.8,
                    }}
                    onClick={openConnectModal}
                  >
                    Connect
                  </Button>
                );
              }
              if (chain.unsupported) {
                return (
                  <Button
                    px={3}
                    rounded={8}
                    bg="transparent"
                    size="xs"
                    fontSize="sm"
                    lineHeight={1.5}
                    fontWeight={500}
                    border="1px solid"
                    borderColor="text.t3"
                    color="text.t1"
                    onClick={openChainModal}
                    type="button"
                  >
                    Wrong network
                  </Button>
                );
              }
              return (
                <HStack gap={3}>
                  {/* <button
                    onClick={openChainModal}
                    style={{ display: 'flex', alignItems: 'center' }}
                    type="button"
                  >
                    {chain.hasIcon && (
                      <div
                        style={{
                          background: chain.iconBackground,
                          width: 12,
                          height: 12,
                          borderRadius: 999,
                          overflow: 'hidden',
                          marginRight: 4,
                        }}
                      >
                        {chain.iconUrl && (
                          <img
                            alt={chain.name ?? 'Chain icon'}
                            src={chain.iconUrl}
                            style={{ width: 12, height: 12 }}
                          />
                        )}
                      </div>
                    )}
                    {chain.name}
                  </button> */}
                  <Button
                    px={3}
                    rounded={8}
                    bg="transparent"
                    size="xs"
                    fontSize="sm"
                    lineHeight={1.5}
                    fontWeight={500}
                    border="1px solid"
                    borderColor="text.t3"
                    color="text.t1"
                    onClick={openAccountModal}
                  >
                    {account.displayName}
                  </Button>
                </HStack>
              );
            })()}
          </div>
        );
      }}
    </ConnectButton.Custom>
  );
};
